import { render, staticRenderFns } from "./ControlProductAmount.vue?vue&type=template&id=264cb1e7&scoped=true&"
import script from "./ControlProductAmount.vue?vue&type=script&lang=ts&"
export * from "./ControlProductAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264cb1e7",
  null
  
)

export default component.exports